import { w as withConfigTransport } from "../../services/config-transport/withConfigTransport-31ef3979.mjs";
import { _ as _VaNavbar } from "./VaNavbar-7ebbeb69.mjs";
import { _ as _VaNavbarItem } from "./VaNavbarItem/VaNavbarItem-af4ae844.mjs";
const VaNavbar = withConfigTransport(_VaNavbar);
const VaNavbarItem = withConfigTransport(_VaNavbarItem);
export {
  VaNavbar as V,
  VaNavbarItem as a
};
//# sourceMappingURL=index-2cc04440.mjs.map
